module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-alert"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "fadeInDown",
      "leave-active-class": "fadeOutUp"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "vbl-alert-content"
  }, [_c('vbl-icon', {
    attrs: {
      "type": _vm.iconType
    }
  }), _vm._v("\n            " + _vm._s(_vm.content) + "\n        ")], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35e1f0db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblAlert/src/vblAlert.vue
// module id = 256
// module chunks = 0